import {
    inject,
    observer
} from 'mobx-react'
import {
    WeaDialog,
    WeaRightMenu
} from 'ecCom'

//根据情况import组件
import Tab from './Tab';
import Table from './Table';

@inject('hrmUsedemand') //todo
@observer
export default class MainDialog extends React.Component {
    constructor(props) {
        super(props);
    }

    getChildren = () => {
        return (
            <div>
                <Tab />
                <Table />
            </div>
        )
    }

    render() {
        const {
            hrmUsedemand
        } = this.props, {
            mainDialog,
            closeDialog,
            buttons,
            style,
            dropMenuDatas,
        } = hrmUsedemand, {
            title,
            visible,
        } = mainDialog;

        return (
            <WeaDialog
                title={title}
                icon="icon-coms-hrm"
                iconBgcolor="#217346"
                visible={visible}
                hasScroll={true}
                onCancel={() => closeDialog()}
                buttons={buttons}
                style={style}
            >
                <WeaRightMenu datas={dropMenuDatas}>
                    {visible && this.getChildren()}
                </WeaRightMenu>
            </WeaDialog>
        )

    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/useDemand/MainDialog.js